import { getNetworkRequestDefaultData } from '@src/api/networkRequestDefault';
import { useQuery } from '@tanstack/react-query';

export const useRequestDefault = (interval, metricFilter, filter, groupBy) => {
  return useQuery(
    [interval, metricFilter, filter, 'request_default'],
    async () => {
      if (!interval) {
        return [];
      }
      const res = await getNetworkRequestDefaultData({
        interval,
        metricFilter,
        filter,
        groupBy,
      }).then((response) => {
        return response?.data;
      });
      return res;
    },
    { retryOnMount: false, refetchOnWindowFocus: false },
  );
};
